import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('USER_FOLLOWINGS').plugin(axiosPlugin, {template: "array"});

let fetchUserFollowingsAction = redux.fetchActionGet();

export const fetchUserFollowings = (userId, query = {}) => fetchUserFollowingsAction(`/users/${userId}/followings?${queryString.stringify(query)}`);
export const resetUserFollowings = () => redux.actions.reset();

export const userFollowings = redux.reducer();